import { useCallback, useReducer } from "react";
import Request from "../helpers/request.service";
import { removeEmptyVals } from "../helpers/helper";
import Notification from "../helpers/Notification";

const initialState = {
  data: null,
  loading: false,
  error: null,
};

const reducer = (state, action) => {
  switch (action.type) {
    case "loading":
      return { ...state, loading: action.payload, error: null };
    case "data":
      return { ...state, data: action.payload, loading: false };
    case "error":
      return { ...state, error: action.payload, loading: false };
    case "reset":
      return initialState;
    default:
      return state;
  }
};

export const usePatch = ({
  url = "",
  data = {},
  config = {},
  onCompleted = null,
  onError = null,
} = {}) => {
  const [state, dispatch] = useReducer(reducer, initialState);

  const fetchData = useCallback(
    async (
      runQueryURL = url,
      runQueryData = data,
      runQueryConfig = config
    ) => {
      dispatch({ type: "reset" });
      dispatch({ type: "loading", payload: true });

      try {
        const filteredParams = removeEmptyVals(runQueryConfig);
        const params = new URLSearchParams(filteredParams).toString();
        const queryParams = params ? `?${params}` : "";
        const res = await Request.patchJson(runQueryURL + queryParams, runQueryData);

        if (res?.data?.status && res.data.status >= 400) {
          const errorMessage = res.data.message || `Error ${res.data.status}`;
          dispatch({ type: "error", payload: errorMessage });

          if (onError) {
            onError(errorMessage);
          }

          return res;
        }

        dispatch({ type: "data", payload: res?.data });

        const successMessage = res?.data?.message;
        if (successMessage) {
          Notification.success(successMessage);
        }

        if (onCompleted) {
          onCompleted(res?.data);
        }

        return res;
      } catch (error) {
        let errorMessage = "An error occurred";
        let statusCode = 500;

        if (error?.response) {
          statusCode = error.response.status || 500;
          errorMessage =
            error.response.data?.message || `Server Error (${statusCode})`;
        } else if (error?.message) {
          errorMessage = error.message;
        }

        dispatch({ type: "error", payload: errorMessage });

        if (onError) {
          onError(errorMessage);
        }

        return {
          data: {
            status: statusCode,
            message: errorMessage,
          },
        };
      }
    },
    [url, data, config, onCompleted, onError]
  );

  return { ...state, runQuery: fetchData };
};
